import React from 'react';
import PropTypes from 'prop-types';
import SongStore from '../stores/SongStore';

export default class Meter extends React.Component {
  static propTypes = {
    name: PropTypes.string,
    low: PropTypes.number,
    high: PropTypes.number,
    max: PropTypes.number
  };

  static contextTypes = {
    getStore: PropTypes.func.isRequired
  };

  constructor(props, context) {
    super(props, context);

    this.state = {
      value: 0
    };

    this.context.getStore(SongStore).on('VU_METER_UPDATE', (data) => {
      this.setState({
        value: data[this.props.number]
      });
    });
  }

  render() {
    return (
      <meter low={this.props.low} high={this.props.high} max={this.props.max} value={this.state.value} />
    );
  }
}
